import React, { useState } from "react";
import { Link } from "react-router";
import { useTranslation } from "react-i18next";
import { Menu, X, Phone, Calculator } from "lucide-react";

import { Button } from "./ui/button";
import LanguageSwitcher from "./LanguageSwitcher";
import { WHATSAPP_NUMBER, whatsappUrl } from "../config/contact";

import logo from "../assets/images/logo.png";

const sections = ["home", "tours", "about", "contact"] as const;

export default function AppBar() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { t } = useTranslation();

  const closeMenu = () => setMobileMenuOpen(false);

  return (
    <header className="fixed top-0 z-50 w-full border-b border-slate-100 bg-white/90 backdrop-blur-md transition-all">
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-3 px-4 py-3 sm:px-6 sm:py-4">
        <Link to="/" className="inline-flex shrink-0 items-center gap-2" onClick={closeMenu}>
          <img src={logo} alt="MB Floripa Turismo" className="h-10 w-auto" />
        </Link>

        {/* Desktop */}
        <nav className="hidden items-center gap-6 font-medium text-slate-700 md:flex lg:gap-8">
          {sections.map((section) => (
            <a key={section} href={`/#${section}`} className="transition-colors hover:text-primary">
              {t(`nav.${section}`)}
            </a>
          ))}
          <Link
            to="/orcamento"
            className="inline-flex items-center gap-1.5 text-primary transition-colors hover:text-primary/80"
          >
            <Calculator className="h-4 w-4" />
            {t("nav.quote")}
          </Link>
          <LanguageSwitcher />
          <Button size="sm" className="rounded-full px-5 shadow-md" asChild>
            <a href={whatsappUrl(WHATSAPP_NUMBER)} target="_blank" rel="noreferrer">
              <Phone className="h-4 w-4" />
              {t("nav.book")}
            </a>
          </Button>
        </nav>

        {/* Mobile */}
        <div className="flex items-center gap-2 md:hidden">
          <LanguageSwitcher />
          <button
            type="button"
            className="rounded-full p-2 text-slate-900 hover:bg-slate-100"
            aria-expanded={mobileMenuOpen}
            aria-label={mobileMenuOpen ? t("nav.close") : t("nav.menu")}
            onClick={() => setMobileMenuOpen((open) => !open)}
          >
            {mobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="absolute left-0 top-full w-full border-t border-slate-100 bg-white shadow-lg md:hidden">
          <div className="flex flex-col gap-1 p-4">
            {sections.map((section) => (
              <a
                key={section}
                href={`/#${section}`}
                className="rounded-xl px-3 py-3 text-lg font-medium text-slate-900 hover:bg-slate-50 hover:text-primary"
                onClick={closeMenu}
              >
                {t(`nav.${section}`)}
              </a>
            ))}
            <Link
              to="/orcamento"
              className="inline-flex items-center gap-2 rounded-xl px-3 py-3 text-lg font-medium text-primary hover:bg-primary/5"
              onClick={closeMenu}
            >
              <Calculator className="h-5 w-5" />
              {t("nav.quote")}
            </Link>
            <Button className="mt-2 h-12 w-full rounded-xl text-base" asChild>
              <a href={whatsappUrl(WHATSAPP_NUMBER)} target="_blank" rel="noreferrer">
                <Phone className="h-4 w-4" />
                {t("nav.book")}
              </a>
            </Button>
          </div>
        </div>
      )}
    </header>
  );
}
